import * as React from "react";
import { Form, NestedField, Text, RadioGroup, Radio, TextArea, Checkbox, Select } from 'react-form';
import { api } from "./api";
import { classNames } from "./theme";

export interface FormState {
    item?: any;
    errors?: any;
}

interface Props {
    form?: Form;
    model?: string;
    fields?: string[];
    fieldsParams?: {
        [s: string]: {
            label?: string | null;
            type?: "string" | "select" | "textarea" | "bit",
            options?: {
                label: string,
                value: string | number
            },
            size?: number
        }
    };
    errors?: any;
    validate?: any;
}

class Address extends React.Component<any> {
    render() {
        return (
            <Fieldset
                form={this.props['form']}
                model="address"
                fieldsParams={{
                    'indirizzo': { label: null, size: 100 },
                    'comune': { size: 50 },
                    'id_provincia': { size: 50 },
                    'cap': { size: 50 }
                }}
            />
        );
    }
}


class Fieldset extends React.Component<Props> {

    componentWillReceiveProps( nextProps ) {
        if (nextProps.validate !== this.props.validate) {
            this.validateAll()
        }
    }
    
    detectType( field ) {
        if (!field || !field.type) {
            return "string";
        }
        var type = field.type;
        // automagically guess input type [TODO]
        if (type === "enum") {
            return "select";
        }
        return type; // default
    }
    
    validate( field, v ) {
        //const { touched } = form;
        const id = field.id;
        // if (!touched[id]) return;
        if (this.isVisible(field) && this.isRequired(field)) {
            let msg = Object.keys(field.validator).reduce( (msg, k) => { return k.includes('required') ? field.validator[k] : msg }, null );
            if (!msg || msg.length === 0) msg = "Campo richiesto";
            return (!v || v.length === 0) ? msg : null;
        }
    }

    validateAll() {
        const { form } = this.props;
        const values = form.values;
        const [all_fields, _fields] = this.prepareFields();
        all_fields.forEach( (key) => {
            const field = _fields[key];
            const err = this.validate(field, values[key]);
            form.setError(key, err);
        });
    }
    
    isRequired( field ) {
        const { form } = this.props;
        let values;
        if (form) {
            values = form.values;
        }
        
        // validate
        const kk = Object.keys(field.validator || {});
        for (let i=0; i<kk.length; i++) {
            let k = kk[i];
            if (k === "required") return true;
            /***
             * The field under validation must be present and not empty if the anotherfield field is equal to any value.
             */
            if (k.includes('required_if') === true) {
               const [other_field, other_value] = k.split(':')[1].split(',');
               if (values[other_field] === other_value) {
                   return true;
               }
            }
            /***
             * The field under validation must be present and not empty only when any of the other specified fields are not present.
             */
            if (k.includes('required_without') === true) {
               const others = k.split(':')[1].split(',');
               const anyEmpty = others.filter( o => !values[o] || values[o].length === 0 ).length > 0;
               return (anyEmpty);
            }
        }
        return false;
    }

    isVisible( field ) {
        const { form } = this.props;
        let values;
        if (form) {
            values = form.values;
        }
        
        // conditionally
        if (field.visible_when) {
            const [other_field, other_value] = field.visible_when.split('=');
            if (values[other_field] !== other_value) {
                return false;
            }
        }
        return true;
    }

    private prepareFields() {
        const { form, model, fields = [], fieldsParams = {}, errors } = this.props;
        var _fields = {};
        let all_fields = fields.concat(Object.keys(fieldsParams)).filter((el, i, a) => i === a.indexOf(el)); // concat and unique
        if (model && all_fields.length == 0) {
            // all fields from model!
            all_fields = Object.keys(struct[model]);
        }
        all_fields.forEach( key => {
            const params = fieldsParams[key];
            
            var _field;
            if (model && struct[model] && struct[model][key]) {
                // augment from struct
                _field = {
                    ...struct[model][key]
                }
            }
            // override
            _field = {
                ..._field,
                id: key,
                type: this.detectType(_field)
            }
            if (params) {
                _field = {
                    ..._field,
                    ...params,
                }
            }
            // load options
            if (
                (_field.type === "select") ||
                (_field.type === "radio")
            ) {
                if (_field.params && lists[_field.params]) {
                    // options from static lists
                    const lp = lists[_field.params];
                    const kk = Object.keys(lp);
                    const options = kk.map( k => ({ label: lp[k], value: k}))
                    _field = {
                        ..._field,
                        options
                    }
                } 
            }
            _fields[key] = _field;
        });
        return [all_fields, _fields] as any;
    } 
    
    
    render() {
        const { form, model, fields = [], fieldsParams = {}, errors } = this.props;
        const keys = Object.keys(fieldsParams);
        
        const [all_fields, _fields] = this.prepareFields();
        return (
            <div className="row">
            {all_fields.map( (key) => {
                const field = _fields[key];
                const {id, label, type = "string", options = [], size = 100, validator = [] } = field;
                const err = (errors && errors[id]) ? errors[id] : null;
                const css = ""; // form-control
                const cssField = `col-sm-${(12 * size/100)}`;
                const isRequired = this.isRequired(field);
                const isVisible = this.isVisible(field);
                if (!isVisible) return null;
                
                const fieldProps = {
                    field: id,
                    id: id,
                    className: css,
                    //validate: (v) => { return this.validate(field, v); },
                }
                return (
                    <div className={classNames("field", `field-${type}`, cssField, isRequired ? "required" : null, err ? "error" : null)} key={key}>
                        {label &&
                        <label htmlFor={id}>{label}</label>
                        }
                        {type === "string" &&
                        <Text type="text" {...fieldProps} />
                        }
                        {type === "textarea" &&
                        <TextArea {...fieldProps} />
                        }
                        {type === "select" &&
                        <Select {...fieldProps} placeholder="Seleziona" options={options} />
                        }
                        {type === "radio" &&
                        <RadioGroup {...fieldProps}>
                        <div className="radio-group">
                            {options.map( (o,i) => (
                            <div key={i}>
                                <div className="radio">
                                    <Radio value={o.value} id={`${id}_${i}`} />
                                    <label htmlFor={`${id}_${i}`}>{o.label}</label>
                                </div>
                            </div>
                            ))}
                        </div>
                        </RadioGroup>
                        }
                        {type === "address" &&
                        <NestedField {...fieldProps}><Address form={form} /></NestedField>
                        }
                        {err &&
                        <p>{ err }</p>
                        }
                    </div>
                );
            })}
            </div>
        );
    }
}


// init
var struct;
var lists;
const initForm = async () => {
    const data = await api( {
        url: "structDef"
    } );
    struct = data.models;
    lists = data.lists;
}
initForm()

function bindToAPI( context, config ) {
    return new Promise<any>( (resolve, reject) => {
        api( config ).then( (data) => {
            resolve( data );
            context.setState(resetState());
        })
        .catch( (errors) => {
            reject( errors );
            context.setState({
                errors
            });
        })
    });
}

function resetState( args = {} ) {
    return {
        ...args,
        item: null,
        errors: null
    }
}

const _ = {
    pluck: (arr, label, value = "id") => {
        return arr.map(function(item) {
            return {
                label: item[label],
                value: item[value]
            }
        });
    }
};

export {
    Form,
    Fieldset,
    bindToAPI,
    resetState,
    _
}


// WEBPACK FOOTER //
// ./src/services/form.tsx